
let format = (value) => {
  return value >= 10 ? value : '0' + value
}

let transNum = (num) => {
  let result = ''
  switch (num)
  {
    case 0:
      break
    case 1:
      result = '一'
      break
    case 2:
      result = '二'
      break
    case 3:
      result = '三'
      break
    case 4:
      result = '四'
      break
    case 5:
      result = '五'
      break
    case 6:
      result = '六'
      break
    case 7:
      result = '七'
      break
    case 8:
      result = '八'
      break
    case 9:
      result = '九'
      break
  }
  return result
}
/**
 * 时间格式化
 */
export let dateFilter = (time, type) => {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let second = date.getSeconds()
  let result
  switch (type)
  {
    case 0: // 01-05
      result = `${format(month)}-${format(day)}`
      break
    case 1: // 11:12
      result = `${format(hours)}-${format(minutes)}`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`
      break
    case 4: // 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 5: // 01月05日 11:12
      result = `${format(month)}月${format(day)}日 ${format(hours)}:${format(minutes)}`
      break
    case 6: // 2015年1月5日
      result = `${format(year)}年${month}月${day}日`
      break
    case 7: // 2015年1月
      result = `${format(year)}年${format(month)}月`
      break
  }
  return result
}
/* 判空 */
export let judgeNull = (content) => {
  let result
  switch (content)
  {
    case null:
      result = ''
      break
    case content:
      result = content
      break
  }
  return result
}
// 审核状态
export let auditStatusFilter = (code) => {
  let result
  switch (code)
  {
    case 0:
      result = '未审核'
      break
    case 1:
      result = '审核通过'
      break
    case 2:
      result = '审核不通过'
      break
  }
  return result
}

// 数字转汉字 一百以下
export let chineseNum = (num) => {
  let tens = Math.floor(num / 10)
  let units = num % 10
  let result = ''
  if (tens === 0) {
    result = transNum(units)
  }
  else if (tens === 1) {
    result = `十${transNum(units)}`
  }
  else if (tens > 1) {
    result = `${transNum(tens)}十${transNum(units)}`
  }
  return result
}

export let formatDate = (timeStamp, type = 'Y-M-D H:I:S', auto = false) => {
    // console.log(timeStamp)
    let formatTime = '';
    if((timeStamp).toString().indexOf("T") != -1){
        let d = new Date(timeStamp);
        let hours = d.getHours() < 10 ? ("0" + d.getHours()) : d.getHours();
        let minutes = d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes();
        let seconds = d.getSeconds() < 10 ? ("0" + d.getSeconds()) : d.getSeconds();
        formatTime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + hours + ':' + minutes + ':' + seconds;
    }else{
      let time = (timeStamp + '').length === 10 ? new Date(parseInt(timeStamp) * 1000) : new Date(parseInt(timeStamp));
      let _year = time.getFullYear();
      let _month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
      let _date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
      let _hours = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
      let _minutes = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
      let _secconds = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
      
      let distinctTime = new Date().getTime() - time.getTime();

      if (auto) {
          if (distinctTime <= (1 * 60 * 1000)) {
              // console.log('一分钟以内，以秒数计算');
              let _s = Math.floor((distinctTime / 1000) % 60);
              formatTime = _s + '秒前';
          } else if (distinctTime <= (1 * 3600 * 1000)) {
              // console.log('一小时以内,以分钟计算');
              let _m = Math.floor((distinctTime / (60 * 1000)) % 60);
              formatTime = _m + '分钟前';
          } else if (distinctTime <= (24 * 3600 * 1000)) {
              // console.log('一天以内，以小时计算');
              let _h = Math.floor((distinctTime / (60 * 60 * 1000)) % 24);
              formatTime = _h + '小时前';
          } else if (distinctTime <= (30 * 24 * 3600 * 1000)) {
              let _d = Math.floor((distinctTime / (24 * 60 * 60 * 1000)) % 30);
              formatTime = _d + '天前';
              // console.log('30天以内,以天数计算');
          } else {
              // 30天以外只显示年月日
              formatTime = _year + '-' + _month + '-' + _date;
          }
      } else {

          switch (type) {
              case 'Y-M-D H:I:S':
                  formatTime = _year + '-' + _month + '-' + _date + ' ' + _hours + ':' + _minutes + ':' + _secconds;
                  break;
              case 'Y-M-D H:I:S zh':
                  formatTime = _year + '年' + _month + '月' + _date + '日  ' + _hours + ':' + _minutes + ':' + _secconds;
                  break;
              case 'Y-M-D H:I':
                  formatTime = _year + '-' + _month + '-' + _date + ' ' + _hours + ':' + _minutes;
                  break;
              case 'Y-M-D H':
                  formatTime = _year + '-' + _month + '-' + _date + ' ' + _hours;
                  break;
              case 'Y-M-D':
                  formatTime = _year + '-' + _month + '-' + _date;
                  break;
              case 'Y-M-D zh':
                  formatTime = _year + '年' + _month + '月' + _date + '日';
                  break;
              case 'Y-M':
                  formatTime = _year + '-' + _month;
                  break;
              case 'Y':
                  formatTime = _year;
                  break;
              case 'M':
                  formatTime = _month;
                  break;
              case 'D':
                  formatTime = _date;
                  break;
              case 'H':
                  formatTime = _hours;
                  break;
              case 'I':
                  formatTime = _minutes;
                  break;
              case 'S':
                  formatTime = _secconds;
                  break;
              default:
                  formatTime = _year + '-' + _month + '-' + _date + ' ' + _hours + ':' + _minutes + ':' + _secconds;
                  break;
          }
      }
    }
    
    // 返回格式化的日期字符串
    return formatTime;
}

export let getTel = (tel)=>{
    var reg = /^(\d{3})\d{4}(\d{4})$/;  
    return tel.replace(reg, "$1****$2");
}

//只能输入数字
export let getNumber = (event)=>{
    return (/[\d]/.test(String.fromCharCode(event.keyCode)))
}





// WEBPACK FOOTER //
// ./src/util/filter.js